import { BENEFICIOS_DO_GRATIS, BENEFICIOS_DO_PRO, CHAMADA_DO_PRO } from '../../constants/planos';
import { fmtBRL } from '../../hooks/usePlanPrices';
import type { BillingCycle, SubscriptionState } from '../../store/slices/subscription';

// A VITRINE DOS PLANOS (Grátis × Maestra PRO, com o preço do ciclo escolhido), a mesma na web
// (`logica/dinheiro/usePlanos`) e no app (`app/planos`, que mostra e não vende). O preço vem do
// servidor (`fetchPlanConfig`); sem ele, a web mostra o valor de referência e o app espera.

/** O valor de referência da web enquanto o preço do servidor não chega. */
export const PRECO_DE_REFERENCIA_MENSAL = 57.9;

export const vitrineDosPlanos = (
  plan: SubscriptionState['plan'],
  cicloEscolhido: BillingCycle,
  mudarCiclo: (c: BillingCycle) => void,
) => {
  const monthlyValue = plan?.monthlyValue ?? PRECO_DE_REFERENCIA_MENSAL;
  const annualValue = plan?.annualValue ?? null;
  const annualEnabled = !!(plan?.annualEnabled && annualValue && annualValue > 0);
  const isAnnual = cicloEscolhido === 'YEARLY' && annualEnabled;
  const currentValue = isAnnual ? (annualValue as number) : monthlyValue;
  const discountPct = annualValue ? Math.round((1 - annualValue / (monthlyValue * 12)) * 100) : 0;
  const annualPerMonth = annualValue ? annualValue / 12 : 0;

  return {
    titulo: CHAMADA_DO_PRO.titulo,
    apoio: 'O planejamento completo, os módulos e a Nyta Assistente no seu perfil de artista.',
    gratis: { nome: 'Grátis', descricao: 'Para conhecer o momento da carreira pelo Diagnóstico REAL.', preco: 'R$ 0', grupos: BENEFICIOS_DO_GRATIS },
    pro: {
      nome: 'Maestra PRO',
      descricao: 'Ferramentas para executar o plano e crescer mais rápido.',
      preco: fmtBRL(currentValue),
      unidade: isAnnual ? '/ano' : '/mês',
      nota: isAnnual ? `equivale a ${fmtBRL(annualPerMonth)}/mês` : null,
      grupos: BENEFICIOS_DO_PRO,
    },
    ciclo: annualEnabled ? {
      valor: (isAnnual ? 'YEARLY' : 'MONTHLY') as BillingCycle,
      mudar: mudarCiclo,
      economia: discountPct > 0 ? `-${discountPct}%` : null,
    } : null,
    /** O preço veio do servidor (o app só mostra o preço quando isto é verdade). */
    precoConfirmado: !!plan?.monthlyValue,
  };
};
